import {
  Component,
  ComponentRef,
  ElementRef, EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {DsDropdownListComponent} from "../ds-dropdown/ds-dropdown-list/ds-dropdown-list.component";

interface ListItem {
  name: string;
  id?: number;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-chip-input',
    templateUrl: './ds-chip-input.component.html',
    styleUrls: ['./ds-chip-input.component.scss'],
    standalone: false
})
export class DsChipInputComponent implements OnInit, OnDestroy {
  private selected: boolean;

  @Input() set options(ops: ListItem[]) {
    this.allOptions = ops;
    this.filteredOptions = ops;
    if (!this.input?.nativeElement?.value) {
      this.filteredItems = this.filteredOptions;
    }
  }

  allOptions: ListItem[] = [];
  filteredOptions: ListItem[] = [];
  @Input() placeholder = '';
  @Input() withCheckboxes = false;
  @Input() checkboxOptions: any[];
  @Input() isDark: boolean;
  @Input() showClose: boolean = true;
  @Input() listForm: FormArray;
  @Output() onAdd: EventEmitter<ListItem[]> = new EventEmitter<ListItem[]>();
  filteredItems: ListItem[] = [];
  inputFormControl = new FormControl();
  private readonly _click: Function;
  private _componentRef: ComponentRef<DsDropdownListComponent>;
  @ViewChild('itemInput') input: ElementRef;
  @ViewChild('elementBody') elementBody: ElementRef;
  showDropdown = false;
  private readonly _subscription: Function;


  constructor(private _fb: FormBuilder,
              private _renderer2: Renderer2) {
    this._subscription = this._renderer2.listen(document, "click", e => {
      if (e.target !== this.elementBody.nativeElement && !this.elementBody.nativeElement.contains(e.target)) {
        this.showDropdown = false;
      }
    });
  }

  ngOnInit() {
    this.inputFormControl.valueChanges
      .subscribe(val => {
        this.updateAutocomplete();
      });
  }


  remove(index: number) {
    if (index !== -1) {
      const item = this.listForm.at(index).value;
      this.listForm.removeAt(index);
      this.filteredOptions = this.allOptions.filter((opt) => opt.id !== item.id);
      this.listForm.parent.markAsDirty();
    }
  }

  onFocusOut(value) {
    setTimeout(() => {
      if (this.selected) {
        this.selected = false;
        return;
      }
      this.add(value);
    }, 500);
  }

  add(value: any, closeDropdown = true) {
    if (value && !value.name) {
      return;
    }
    this.selected = true;
    if (value) {
      this.listForm.push(this._createFormGroup(value));
      this.onAdd.emit(this.listForm.getRawValue());
    }
    if (closeDropdown) {
      this.showDropdown = false;
    }

    this.filteredOptions = this.filteredOptions.filter(opt => opt.id !== value.id);
    this.input.nativeElement.value = '';
    this.listForm.parent.markAsDirty();
    this.listForm.markAsDirty();
  }

  private _createFormGroup(value): FormGroup {
    return this._fb.group(value);
  }

  updateAutocomplete() {
    this.showDropdown = true;
    const inputValue = this.inputFormControl.value.toLowerCase();
    this.filteredItems = this.filteredOptions.filter(
      (item) => item.name.toLowerCase().indexOf(inputValue) > -1
    );
  }

  onBackspace(value) {
    if ((value === '' || value === null) && this.listForm.controls.length) {
      this.remove(this.listForm.controls.length - 1);
    }
  }

  checkboxValueChange(option, checked: boolean) {
    if (checked) {
      const index = this.listForm.controls.findIndex(item => item.get('name').value === option.name);
      this.remove(index);
      return;
    }
    this.add(option, false);
  }

  checkSelectedOptions(id: string): boolean {
    return this.listForm.controls.some(item => {
      return item.get('name').value === id;
    });
  }

  ngOnDestroy() {
    this._subscription();
  }

}
